// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormClose } from 'grommet-icons';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import StyledFormCheckmark from 'esm-web-pro/components/layout/sidePanel/icons/StyledFormCheckmark';

type Props = {
    providerName: string,
    objectName: string,
    pointDisplayValues: {
        model: string,
        level?: string,
    },
    pointData: {
        model: string,
        level: string,
        underground_connection: boolean,
    }
};

const PointAttributes = (props: Props) => {
    const {
        providerName,
        objectName,
        pointDisplayValues,
        pointData: {
            model, level, underground_connection: undergroundConnection,
        },
    } = props;

    const attributes = [
        {
            label: <FormattedMessage id="point-attributes-provider" defaultMessage="Infrastructure Provider" />,
            value: providerName,
        },
        {
            label: <FormattedMessage id="point-attributes-object" defaultMessage="Object" />,
            value: objectName,
        },
    ];

    if (model) {
        attributes.push({
            label: <FormattedMessage id="point-attributes-model" defaultMessage="Model" />,
            value: pointDisplayValues.model,
        });
    }

    if (level) {
        attributes.push({
            label: <FormattedMessage id="point-attributes-level" defaultMessage="Level" />,
            value: pointDisplayValues.level || level,
        });
    }

    if (typeof undergroundConnection !== 'undefined') {
        attributes.push({
            label: (
                <FormattedMessage
                    id="point-attributes-underground-connection"
                    defaultMessage="Underground connection"
                />
            ),
            value: undergroundConnection ? <StyledFormCheckmark /> : <FormClose />,
        });
    }

    return (
        <Attributes attributes={attributes} />
    );
};

export default PointAttributes;
